import gql from 'graphql-tag'

export default gql`
mutation updateBatchTrackingFlash($labelIds: [String!]) {
  updateBatchTrackingFlash(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateBatchTrackingFlash.js